import { atom } from "@reatom/framework";
import { OrderResponseDto } from "definitions/poizon-bff";
import { OrderResponseDtoStatusEnum } from "definitions/poizon-bff";
import { PAGINATION_DEFAULT_STATE } from "src/constants/pagination";

import { getOrdersWithFilters } from "../action";

export const ordersFiltersAtom = atom(
  {
    status: "" as string | OrderResponseDtoStatusEnum,
    page: PAGINATION_DEFAULT_STATE.page,
    pageSize: PAGINATION_DEFAULT_STATE.pageSize,
  },
  "ordersFiltersAtom",
);

export const filteredOrdersAtom = atom((ctx) => {
  const filters = ctx.spy(ordersFiltersAtom);
  const ordersData = ctx.spy(getOrdersWithFilters.dataAtom) as {
    data: OrderResponseDto[];
    totalItems: number;
  };

  if (!filters.status || filters.status === "") {
    return {
      data: ordersData.data,
      totalItems: ordersData.totalItems,
    };
  }

  const filteredData = ordersData.data.filter(
    (order: OrderResponseDto) => order.status === filters.status,
  );

  return {
    data: filteredData,
    totalItems: filteredData.length,
  };
}, "filteredOrdersAtom");
